import React from "react";
import { MessageBubble, MessageWrapper } from "src/components/Messaging/Messages/Message";

interface Props {
    message: string;
}

export const Sending = ({ message }: Props) => {
    return (
        <MessageWrapper user={null}>
            <MessageBubble user={null}>{message}</MessageBubble>
        </MessageWrapper>
    );
};

export default Sending;
